import serviceBloque from '@/services/GsEncuesta/bloque'

export default {
  BLOQUE_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      serviceBloque.findAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  BLOQUE_CREATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceBloque.create(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  BLOQUE_UPDATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceBloque.update(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  BLOQUE_DELETE(_, params) {
    return new Promise((resolve, reject) => {
      serviceBloque.delete(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
